import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/null-draft.svg';
import { onMounted, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Null',
    props: {
        size: {
            type: String,
            default: "auto",
        },
    },
    setup: function (__props) {
        var props = __props;
        var NullImgContainer = ref(null);
        onMounted(function () {
            if (NullImgContainer.value && props.size !== "auto") {
                NullImgContainer.value.style.setProperty("--null-img-size", props.size);
            }
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: "post-draft-null-container flex-center usn",
                style: { "--null-img-size": "auto" },
                ref_key: "NullImgContainer",
                ref: NullImgContainer
            }, _cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                    class: "post-draft-null-img",
                    src: _imports_0
                }, null, -1)
            ]), 512));
        };
    }
});
